import { Box, Tooltip, styled } from "@mui/material";
import { TreeItem, treeItemClasses } from "@mui/x-tree-view";
import { useState } from "react";
import { useThemes } from "../Theme/theme";
import { Delete, Edit } from "@mui/icons-material";

import DeleteModal from "./DeleteModal";
const CustomTreeItem = styled(TreeItem)(({ theme }) => ({
  [`& .${treeItemClasses.content}`]: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    height: "40px",
    // border: "1px solid #ffffff",
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      left: -10,
      bottom: "50%",
      transform: "translateY(50%)",
      width: 10,
      // borderBottom: `2px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
  },
  [`& .${treeItemClasses.groupTransition}`]: {
    marginTop: -8,
    marginLeft: 5,
    paddingLeft: 8,
    // borderLeft: `2px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    position: "relative",
  },
  [`& .${treeItemClasses.root}`]: {
    "&:last-child .${treeItemClasses.groupTransition}": {
      borderLeft: "none",
    },
  },
  [`& .singleChild .${treeItemClasses.groupTransition}`]: {
    "&:before": {
      content: '""',
      position: "absolute",
      left: -8,
      top: -12,
      height: 12,
      // borderLeft: `2px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
  },
}));
const ViewRecursiveListItem = ({
  item,
  rows,
  removeNodeByValue,
  deleteGroup,
  data,
  setEditModal,
  setOpen,
  loc,
  setEditData,
  getAccountData,
}) => {
  const { theme } = useThemes();
  const [deleteModal, setDeleteModal] = useState(false);
  const handleDelete = (e) => {
    e.stopPropagation();
    setDeleteModal(true);
  };
  return (
    <>
      <CustomTreeItem
        itemId={item?.value}
        label={
          <Box sx={{ width: "100%", display: "flex" }}>
            <Box
              sx={{
                width: "100%",
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                WebkitLineClamp: 2, // Limits to 2 lines
                lineHeight: "1.5", // Adjust based on typography line height
                maxHeight: "3em",
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {item.label}
            </Box>

            <Box
              sx={{
                whiteSpace: "nowrap",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Tooltip EditTooltip title={`Edit group`} placement="bottom">
                <button
                  // className="button-container"
                  style={{
                    border: 0,
                    backgroundColor: theme.palette.secondary.main,
                    width: 25,
                    height: 25,
                    borderRadius: 4,
                    cursor: "pointer",
                    boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.5)",
                    marginLeft: 10,
                    visibility:
                      item["value"] != 15 && item["value"] != 7
                        ? "visible"
                        : "hidden",
                  }}
                  onClick={(e) => {
                    // if (Freeze == 1) {
                    //   return handleFreeze();
                    // }
                    e.stopPropagation();
                    setEditData(item);
                    setEditModal(true);
                  }}
                >
                  <Edit
                    fontSize="large"
                    sx={{ fontSize: "15px", color: "#fafafb" }}
                  />
                </button>
              </Tooltip>
              <Tooltip title={`Delete Group`} placement="bottom">
                <button
                  // className="button-container"
                  style={{
                    border: 0,
                    backgroundColor: theme.palette.shadow.secondary,
                    width: 25,
                    height: 25,
                    borderRadius: 4,
                    marginLeft: 10,
                    cursor: "pointer",
                    boxShadow: "0px 6px 8px rgba(0, 0, 0, 0.5)",
                    alignItems: "center",
                    visibility:
                      item["value"] != 15 && item["value"] != 7
                        ? "visible"
                        : "hidden",
                  }}
                  onClick={handleDelete}
                >
                  <Delete
                    fontSize="large"
                    sx={{ fontSize: "15px", color: "#fafafb" }}
                  />
                </button>
              </Tooltip>
            </Box>
          </Box>
        }
      >
        {item?.children?.length !== 0 ? (
          <>
            {item?.children?.map((child) => {
              return (
                <ViewRecursiveListItem
                  item={child}
                  deleteGroup={deleteGroup}
                  rows={rows}
                  setOpen={setOpen}
                  removeNodeByValue={removeNodeByValue}
                  loc={loc}
                  data={data}
                  setEditData={setEditData}
                  setEditModal={setEditModal}
                  getAccountData={getAccountData}
                />
              );
            })}
          </>
        ) : null}
      </CustomTreeItem>
      {deleteModal && (
        <DeleteModal
          open={deleteModal}
          setOpen={setDeleteModal}
          func={() => {
            deleteGroup(item?.value, removeNodeByValue);
          }}
          text="Group"
        />
      )}
    </>
  );
};
export default ViewRecursiveListItem;
